<template>
    <div class="articleListModule">

        <div class="categoryArea autoOverflow hiddenScrollbar">
            <div class="clearfix" :style="'width: ' + ((categoryList.length + 1) * 90) + 'px'">
                <div class="categoryItem" :class="{active : activeCategory === ''}"
                     @click="changeCategory(null)">
                    推荐
                </div>
                <div class="categoryItem" :class="{active : catItem.id === activeCategory}"
                     v-for="catItem in categoryList" :key="catItem.id" @click="changeCategory(catItem)">
                    {{catItem.name}}
                </div>
            </div>
        </div>

        <div class="paddingH8">

<!--            <div class="paddingB20">-->
<!--                <bannerModule ref="bannerModule" version="4" categoryKey="NEWS_INDEX" />-->
<!--            </div>-->

            <div class="articleList" style="margin-top: 30px;">
                <div class="dataItem bottomBorderF5F5F5" v-for="dataItem in dataList" :key="dataItem.id"
                     style="margin-bottom: 20px;"
                     @click="viewItem(dataItem)">
                    <div class="titleArea color101010 font14r bold hiddenOverflow"
                         style="max-height: 48px; line-height: 24px;">
                        <strong class="marginR4">{{dataItem.title}}</strong>
                        <i class="icon newIcon relative" style="top: 6px;" v-if="isToday(dataItem.createTime)"></i>
                    </div>
                    <div class="font12r clearfix marginT20" style="line-height: 24px; padding-left: 10px; padding-bottom: 16px;">
                        <div class="floatL">
                            <img class="size24 circle fl marginR4" :src="dataItem.userImg">
                            <span class="font12r" style="color: hsla(219, 9%, 39%, 1)">
                                {{dataItem.userName}}
                            </span>
                        </div>
                        <span class="color777 marginL16">{{formatDate(dataItem.createTime)}}</span>
                        <div class="fr orange" style="padding-right: 12px;">
                            <i class="icon eyeIcon fl marginR4"></i>
                            <!-- 浏览量：真实值+虚拟值 -->
                            {{dataItem.pv + dataItem.pvSham}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="alignCenter paddingV8" v-show="status === 'loading'">
                <i class="icon spinner-loader"></i>
            </div>

            <div class="paddingV16 colorCCC font14r alignC"
                 v-show="status == 'ready' &&  dataList.length < 1">
                暂无任何文章
            </div>

            <div class="paddingV16 alignCenter font14r colorCCC"
                 v-show="status=='ready' && pagination.current == pagination.totalPage"
                 :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                没有更多文章了
            </div>

            <div class="paddingV16 colorCCC font14r alignC"
                 v-show="status == 'error'">
                加载数据失败
            </div>

        </div>
    </div>
</template>

<script>
import generalCmpPart from "@comp/part/generalCmpPart";
// util
import appHelper from '@util/appHelper';
import appConfig from "@/appConfig";
import externalApp from "@data/externalApp";
import timeHelper from "@util/timeHelper";
import categoryApi from "@api/category";

const config = {
    apiConfig : {
        list : {
            url : 'portal/article/list',
            dataPath : 'data.rows',
            totalPagePath : 'data.totalPage',
        }
    }
};

export default {
    name: "articleList",
    extends : generalCmpPart,
    data() {
        return {
            apiConfig : config.apiConfig,
            pageSize : 20,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo',

            categoryList : [{
                id : '',
                name : '推荐'
            },{
                id : 'hot',
                name : '新闻热点'
            },],
            activeCategory : '',

            filters : {
                firstCategory : ''
            }
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.redirect(externalApp.oldShixun.baseUrl + 'html/article/detail.html?id=' + dataItem.id);
        },
        changeCategory(catItem) {
            if (!catItem)
            {
                this.activeCategory = this.filters.firstCategory = '';
            }
            else
            {
                this.activeCategory = this.filters.firstCategory = catItem.id;
            }
            this.reloadDataList();
        },
        isToday(timestamp) {
            return timeHelper.isToday(timestamp);
        }
    },
    mounted() {
        categoryApi.loadList('ARTICLE', (data) => {
            this.categoryList = data;
        });
    }
}
</script>

<style lang="scss" scoped>

.eyeIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE20lEQVRoQ+1YW2wUZRQ+Z3ZmtmgEYgPEGismYIIQxNTdhbRoC0YJAm13N000xsT4It4Sow/G4GPlRU003h58MF5e6u5CITQpEQpakd21Yoj1wUuQKl6IlYuVbOd2PP/IbnrZuXW3EpKZp3b2nO8/5zvff/7zD8JV/uBVHj+ECVzpCoYVCCtQIwOhhGoksGb3sAI1U1gjQFgBQSANLW8w/loSB8A2i7ANkZoIoJHZWQKE/IrG+e9xfveLRPAFIH0mLziXx60/TNZYgLmPEjS49lptIroNSOrhgO/n4KOBgiEocUIDIMHHqmLsw+0jlwL5XzYOLCEaWBE1Ll3/NC++CxAXzmXR2T50HhF7ZWPidewZ1YJgBkrAyMS2m4hvIuBNLosMI0I/ofmpAsZ3wk4H+Va0cCOB1M3/tjr5EtDPEaIn5HRxv98kfCVAfRsW6BHzFZbJTsfFCb7nwB9WU/njbotr2cR6InifbVc62hG9ozSefQY7fip5JeKZAOXWLtWthsMsl9XOYPSNgtCOycK414L2pheY1HCICVnjksSoIpU2YfLkWTdM1wSor6VZkyJHWJ+3uDB/RlWgBTvzf5RtJjOxhwCkLma5jdk2+H0ewNoTTRc/LNtQf2KZpsMI29zojE2nVMtsx56RMScbxwQ4+EUc/EkOvtmVAbTalWTxqM1s/x1NuqGKIDscfIYU03oQe4q/23sjm+jgZnDYDZ+IxtSIdjt2f32+ml3VBJg11HOJg+xwj4ckhljzm8o2rO9ht01q2xEdUtOFCq6WjQspVTCqrcdJHFRThS1cLc53+lM1AT0be5Y7xsueeibrcTVdfFvYcSCPciDvevrYBtYjaqr4nu2Xie0ElN7y8kOwnlNSRW4kHgkI6ehSZMxPjyey1rCuRwXkZCZxgBna6hWIXQSgA9FUYZvttzdxG5pgY7g+RBcUy7yZ98OFqXazKsCB7OZAnvfCE78rprG4DMjyEZt4qR8/TuA3TqDJTkYQFpGr6nsmFutndzSVf8E9gWy8lw+qaUZOQSmyvBA7P//blkI2ITbmssAJ9LdepxvGRV9+RL3RdGGXawKXJXSaJbTIC5QisDralf/2PwnFB7lj3evlM1NClFu/SieyMTwkdJEl1OwpIQEyl01sZOPdFmDOKw7xu4TQJSfz/Xbl6r2JbYa4jWq5+ABLaYtHQNPbaCb+CVdus5sP63+Q9V/BZemJc8Dp3LChRBtl6dxXDdf5INuzbrFmRU+wwXK3gHDqQZZtuYEHt49cAhpSZHigfGrrudjdRNIR94ThtCpNrgt0kJUBxcmq6QpPl3MeJXgCJY0vNWKU2DtrlDDgKybI7kbVHmb+lKrobdh54lcnG3/DXJ0GrwoxvgfE0uaahrnKgmKclsxXWd+PObMVaJz+gM+aFY7Sqec4PXURI3vnDhOkN3xdaMg6qpjyj3DNBOl6dCVS5C6WRJLHjQ2OJIgLDVhPyqkv9/npZsLGU0IzgewrZanxKbLoRT/jhr9A+EpJ8JJs/fPavF4ppwZTt0s9Wn2qau3/3y71VbtF+bMK4UY+zFpnfFYh/qzyp/1ZhfCMBHQMJBqWG84dv6KfVfxJY/6tAu+B+Q8p2AphAsH4qr91WIH6cxoMMaxAML7qbx1WoP6cBkMMKxCMr/pb/wvaXBxPiPCT6wAAAABJRU5ErkJggg==');
}
.newIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFGUlEQVRoQ+1YW0xcVRTd55x7L1IH0AZtRGYiUR5TtNbyYZpUqzVNMb6if5r40Q9sTRr5URuDGhvro00aU02qrSbaH2OsmuIjimlE46vGD20rMlCMCQNotAXKI8h9bdcdmGFmGMiUewm0mZOQ4bz23mutvfdhEHSBD3GBx08FAEutYEGBggI+GSikkE8CfV8vKOCbQp8GLj4FmEh0raJrlK5FbPzuk6BAritBrkt2T12cBrINZgQYW0VVXKQfESQaAvEctBGmz4tGzYeqhmk4aToFAMyrWMQ4iYXVQfsN1B7zwbq4tX0WgNMRo94h+i1QZ4tgjImtul7rUhBteeZTCnRfre5ylfp0EXwGblJzzerr+qgnA0BnRN0jSH0cuLdFMMiOWRvtp+6LHADz68z8vhS0joXcl04k1g8T8ztCyvas9eOSxH6X3b9TRSbFWmTqK4LpRTTDr1iKNhJCZd5zG4lpUkjxBc4WZYjGzn3EchNJ0Zxcz0sBZvfxaNxOBI7u9Ds+oikDRLuiveZzWEfzmhrM9FJd3GzprqQKl7TqbAA48RaKr6kzrH8phNicCpL5BLoKQHp+9GMAcEfa3insrYmFjVZU673nDSDE9gF7ksrMIrWepfpobgD8PYLbEAtrLQhgVzbDUwipHwArEeRjOLN/BjjvQ5BPdJVTiIq1ZhLy+RR4qLaCzd1jUh/G22ScNwAxYR+iYn0vHDwKx7/AcYIp0J6hgJceNXHzGZz5D470jBRIm7BLa4QwzyKW/hkASB+HRqXkMqTXCJH8LrmnHF7Pwq1wpfowI+XyKWIvhaYBDGmOVWUrdRMJ1ZoLAHrzduXQT64SADnPcN2ddX323s6I0eE9mKglW4tbITtiPAVWDCj0bFdEH0vUAfOZ2rh1JeaHMX944QBWGCMCBQtjW5MqZCsAANuivdahXKF3RvRtUOWN6UL5Gmrejtp5GfOd0LIdqbcJdfEjANnYuyVVI8xvw2cTAAwCQKkvAGDDlcKqdkitxlvxSS4ARZbVNqkbW3OAaEBwd08DcEodq3RU09YxyW9htuWSUfvAZIk+CJsOABSjjp4UQr4gXOcBYjHCSqKwM0feXSiRQlAgkTbM70Xj1oOeCkyiNb0LeekmXXGMlfh13hTCphdYTZ9zFMwOoXY2o+VGhFQfePckuxsdh2zSRHuZbV1+Tul70LF2BALAMyJsM0pSVaGobs5oo8zvOkgxFdHP4FTJfCCQbm8i3R4BgFdreq1mEHIQKdY0pZD7dG3c3tMVNo6gHu5HrQxAvasCA4BCO5owHNa24I1oS74DUGc8xFZkQmoNDslmyBVKOkUAl6Gt3pgKYrqdnl5JpdWDNIIeH0ePr5wCQG2w3xiroFpSegnu/ZyLjAWlUCogh9fW9lsnvHn6QwbvPzgT1pb6fwldZGZ0Vmq3zXqx0U6jfeapRKCaEUueBhFjqIMygHYBbDeA4V2ZPfICADb+QFB/gYUN6Sbw4vZi/c9ESgmxMXOPx+H0JO6acyowtdGJYP/BZzls1GfZOI75JH5uwN7KhQPIdXOZrOWnwDIJNm8FusPara6Q3yzjuFOhQYFyfB84m0jj5GrHFRRSxTq+9c/fBpcaIGqnA+/R9Wk1lt4x9B34m/y1pQ5yTv9MA2gijV4HywnAW+yqVHd6D9VyAiFdDJI9xrj52bVDdC49tmXxjys/ZBUA+GEviLsFBYJg0Y+NggJ+2AvibkGBIFj0Y6OggB/2grj7P9JBzU+zgKoQAAAAAElFTkSuQmCC');
}
.orange {
    color: #FEA217;
}
.categoryArea {
    padding: 14px 8px;
    .categoryItem {
        float: left;
        width: 90px;
        height: 24px;
        line-height: 24px;
        overflow: hidden;
    }
    .categoryItem.active {
        color: #F28500;
    }
}
</style>